import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import {trackEvent} from '../../../tracking/amplitude/TrackingV2';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../../mutations/MutationTypes';
import {DeleteBaselineVersionInput, DeleteBaselineVersionMutation} from './__generated__/DeleteBaselineVersionMutation.graphql';

const mutation = graphql`
	mutation DeleteBaselineVersionMutation($input: DeleteBaselineVersionInput!) {
		deleteBaselineVersion(input: $input) {
			deletedBaselineVersionId
			project {
				id
				baselineVersions {
					id
					name
					versionNumber
					isActive
					isStandard
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<DeleteBaselineVersionInput>,
	onSuccess?: RelayOnCompleted<DeleteBaselineVersionMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<DeleteBaselineVersionMutation>(environment, {
		mutation,
		variables,
		onCompleted: (response, errors) => {
			if (!errors?.length) {
				trackEvent('Baseline Version', 'Deleted');
			}
			onSuccess?.(response, errors);
		},
		onError: onError,
	});
}

export default {commit};
